// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1620": "809898e6","5545": "20927b2f","8561": "f9cad78a",}[chunkId] + ".css"
}